<template>
  <div class="spacer relative l:visible">
    <div class="curve"></div>
  </div>
  <div class="brands-section padding-xl-vertical">
    <slider
      class="container-l"
      :config="{
        parallax: false,
        speed: 1000,
        effect: 'slide',
        autoplay: {
          delay: 500,
          disableOnInteraction: false,
        },
        navigation: {
          enabled: false,
        },
        loopPreventsSliding: true,
        spaceBetween: 40,
        slidesPerView: 2,
        breakpoints: {
          1024: {
            slidesPerView: 5,
          },
        },
      }">
      <slide v-for="item in finalBrandLogos" :key="item.imageUrl" class="flex-center">
        <div class="brand-logo">
          <img
            class="bg-bg"
            :src="item.imageUrl"
            :alt="item.imageAlt" />
        </div>
      </slide>
    </slider>
  </div>
</template>

<script>
export default {
  props: {
    partnerLogos: {
      type: [Array, Boolean],
      default: false,
    }
  },
  computed: {
    finalBrandLogos() {
      let results = [];

      if (this.partnerLogos) {
        return this.partnerLogos;
      }

      for (let i = 0; i < 10; i++) {
        results.push({
          imageAlt: "Tefal",
          imageCaption: null,
          imageUrl:
            this.getDynamicAssetUrl(`images/brands/${i}.png`)
        });
      }

      return results;
    },
  },
};
</script>

<style lang="scss" scoped>
.brands-section {
  background-color: var(--c-dark-gray);
}

.brand-logo {
  width: 139px;

  @media (min-width: 1024px) {
    width: 225px;
  }

  img {
    width: 100%;
    background-color: var(--c-bg);
  }
}

.spacer {
  background-color: var(--c-dark-gray);
  height: 80px;
  z-index: 0;
}
.curve {
  z-index: -1;
  background-color: var(--c-light-gray);
  height: 100%;
  clip-path: ellipse(115% 135px at 100% -50%);
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
